import { FieldMetaState } from 'react-final-form'

const hasError = <T = string>({
  touched, error, submitError,
}: FieldMetaState<T>) => {
  if (error || submitError) {
    const errors = []

    if (touched && error) {
      errors.push(error)
    }
    if (submitError && submitError.length) {
      errors.push(...submitError)
    }

    return errors.reduce((p, c) => `${p && `${p},`} ${c}`, '')
  }

  return null
}

export default hasError
